module.exports = __webpack_public_path__ + "img/plantsciences-v-474x632.5df60f5e.jpg";